import { type History, HistoryEntryTypeEnum } from "@repo/api";
import { Text } from "@repo/skapa";
import { t } from "@repo/translation";

import { HistoryListViewItem } from "./HistoryListViewItem";

interface FileHistoryItemProps {
  history: History;
}

const getBody = (history: History) => {
  if (history.entryType === HistoryEntryTypeEnum.FILE_SHARED) {
    return t("prompt.attachment_shared");
  }
  if (history.entryType === HistoryEntryTypeEnum.FILE_UNSHARED) {
    return t("prompt.attachment_unshared");
  }
  return null;
};

export const FileHistoryItem = ({ history }: FileHistoryItemProps) => {
  const body = getBody(history);
  return (
    <HistoryListViewItem
      history={history}
      control="default"
      title={history.title}
      description={
        <div>
          {history.details && (
            <Text textStyle="Body.S">{history.details.file_name}</Text>
          )}
          {body && <Text textStyle="Body.S">{body}</Text>}
        </div>
      }
    />
  );
};
